export default __webpack_public_path__ + "static/media/README.8a4b3bc1.md";